import { useQuery } from 'react-query'
import axios from 'axios'

interface IAvvisiPagamento {
  servizioId: number
  emessiDa?: string
  emessiA?: string
}

const getAvvisiPagamentoInsoluti = async (
  _: string,
  { servizioId, emessiDa, emessiA }: IAvvisiPagamento
) => {
  const emessiDaString = emessiDa ? `&emessiDa=${emessiDa}` : ''
  const emessiAString = emessiA ? `&emessiA=${emessiA}` : ''

  const { data } = await axios.get(
    `/avvisi-pagamento?limit=10000&servizio=${servizioId}&conInsoluti=true${emessiDaString}${emessiAString}`
  )

  return data.results
}

const useAvvisiPagamentoInsoluti = ({ servizioId, emessiDa, emessiA }: IAvvisiPagamento) => {
  return useQuery(
    ['avvisiPagamentoInsoluti', { servizioId, emessiDa, emessiA }],
    () => {
      return getAvvisiPagamentoInsoluti('avvisiPagamentoInsoluti', {
        servizioId,
        emessiDa,
        emessiA,
      })
    },
    {
      enabled: !!servizioId && !!emessiDa && !!emessiA,
      // 1 minuto
      // staleTime:   60 * 1000,
    }
  )
}

export default useAvvisiPagamentoInsoluti
